<script>
import { mapState } from 'vuex';

// @vuese
// Komponent do sprawdzania uprawnień
// @group Components
export default {
  name: 'CheckPermission',
  props: {
    // Lista uprawnień
    permissions: {
      type: [String, Array],
      required: false
    },
    // Rodzaj połączenia zapytania o różne uprawnienia
    //AND - wszystkie muszą być spełnione, OR - wystarczy jedno spełnione
    joinType: {
      type: String,
      validator: function(value) {
        return ['AND', 'OR'].indexOf(value) !== -1;
      },
      required: false,
      default: 'AND'
    },
    // Rodzaj encji
    entityId: {
      type: [String, Number],
      required: false
    },
    // Typ encji
    entityType: {
      type: String,
      required: false
    },
    // Określenie czy renderować slot dla posiadających
    // lub nieposiadających uprawnień użytkowników
    renderOn: {
      type: String,
      validator: function(value) {
        return ['authorized', 'unauthorized'].indexOf(value) !== -1;
      },
      default: 'authorized'
    }
  },
  computed: {
    toCheck() {
      const toCheck = Array.isArray(this.permissions) ? this.permissions : [this.permissions];
      if (this.entityId && this.entityType) {
        return toCheck.map(permission => `${permission}:${this.entityType}:${this.entityId}`);
      }
      return toCheck;
    },
    ...mapState({
      hasPermission(state) {
        const checkedPermissions = state.auth.permissions;
        switch (this.joinType) {
          case 'OR':
            return this.toCheck.some(permission => !!checkedPermissions[permission]);
          case 'AND':
            return this.toCheck.every(permission => !!checkedPermissions[permission]);
          default:
            return false;
        }
      }
    })
  },
  beforeMount() {
    this.$store.dispatch('auth/checkPermissions', this.toCheck);
  },
  render() {
    const hasPermission = !this.permissions || !this.permissions.length || this.hasPermission;
    if ((!hasPermission && this.renderOn === 'unauthorized') || (hasPermission && this.renderOn === 'authorized')) {
      return this.$scopedSlots.default({});
    }
  }
};
</script>
